// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_23t7C9gT8tF18hgLPaEuRD","item":"K6mh1aAnDAHtV2mMGAHUQ"};


//////////////////
// WEBPACK FOOTER
// ./ui/Pills.module.css
// module id = 2419
// module chunks = 0